import { Component, OnInit, HostListener, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { WizCommandManager } from '../../services/core/command/wiz-command.manager';
import { WizFocusManager } from '../../services/core/focus/wiz-focus-manager';
import { ngxLoadingAnimationTypes } from './lock/ngx-loading-config';
import { OverlayContainer } from '@angular/cdk/overlay';
import { LOCKED_KEY_CODE, VALUE_ENTER, VALUE_L, VALUE_X, WIZ_EVENT_TYPE, WizMathUtils } from '@wizeoo/akm-core-lib';
import { WizEvent } from '../../events/wiz-event';
import { WizEventManager } from '../../events/wiz-event.manager';

// template du lock applicatif
@Component({
  selector: 'wiz-root',
  template: `<ngx-loading [show]='lock' [config]='config'></ngx-loading>
				     <ng-content></ng-content>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
// classe physique racine pour les applications
// en lien avec le WizCommandManager
export class WizRoot implements OnInit {

  public uuid: string; // génération d'un UUID pour retour des batchs sur cette seule instance

  public elementRef: ElementRef = null;
  public root(): ElementRef {
    return this.elementRef;
  }

  /**
   * mode "spécif" (pour rendu forms)
   */
  public static specifMode: boolean = true; // c'est plus joli que false;

  /**
   * mode "mobile"
   */
  public static mobileMode: boolean = false; // pour les fonctions mobiles (genre caméra);

  /**
   * mode "verbeux" (trace les logs sur mobile)
   */
  public static verboseMode: boolean = false;


  // ####
  // ####
  // #### détection mobile
  // ####

  // lancement en mode mobile
  public static isMobile(): boolean {
    return !!this.mobileMode;
  }

  public static isIOS(): boolean {
    return /iPad|iPhone|iPod/.test(navigator.userAgent)
      || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  }




  // sur construteur, ref view pour dispatch d'events bubbling
  constructor(elementRef: ElementRef, protected wizOverlayContainer: OverlayContainer, private cdref: ChangeDetectorRef) {
    this.uuid = WizMathUtils.createUUID();
    this.elementRef = elementRef;
    WizRoot._instance = this;
    WizEventManager.root = this.elementRef; // alimentation du root sur le gestionnaire d'événements

    this.wizOverlayContainer = wizOverlayContainer;
        // Call the custom method to create the container
    this.wizOverlayContainer[`wizCreateContainer`](this.elementRef.nativeElement);
  }

  // l'instance (unique)
  private static _instance: WizRoot = null;
  /** accesseur sur l'instance, créa si nécessaire */
  public static getInstance(): WizRoot {
    return this._instance;
  }



  // flag de chargement
  public lock: boolean = false;

  // subscription sur le lock du WizCommandManager
  lockSubscription: Subscription;

  // config par défaut du lock
  public config = { animationType: ngxLoadingAnimationTypes.circleSwish,
    secondaryColour: '#000',
    primaryColour: '#FC9B1C',
    fullScreenBackdrop: true,
    backdropBorderRadius: '3px' };


  public static root(): ElementRef {
    if (this.getInstance()) {
      return  this.getInstance().elementRef;
    }
    return null;
  }



  // attention, ne pas oublier le super dans la classe parent
  ngOnInit() {
    this.lockSubscription =
    WizCommandManager.lock.subscribe(
      (lock: boolean) => {
        this.lock = lock;
        this.cdref.markForCheck();
        // console.log(this.lock.toString() + ' ' + lock.toString() + ' lockSubscription');
      }
    );
    // signaler au FocusManager que je suis "ROOT"
    WizFocusManager.getInstance().setRoot(this.elementRef);

  }

  // neutralisation du clavier sur lock (interception keydown)
  // et dispatch des ctrl+Enter et ctrl+backspace
  @HostListener('window:keydown', ['$event'])
  keyEvent(event: KeyboardEvent) {
    // console.log(event);

    // seulement si lock actif
    if (this.lock === true) {
      // TODO JRO utiliser le code plutot que le keyCode et utiliser la librairie de Keycode JS
      // tslint:disable-next-line: deprecation
      if ( event.keyCode === LOCKED_KEY_CODE.TAB ||
        // tslint:disable-next-line: deprecation
        event.keyCode === LOCKED_KEY_CODE.SPACE ) {
          event.preventDefault();
          event.stopImmediatePropagation();
          // console.log(event);
      }
    } else { // pas de lock, dispatch des raccourcis clavier GLOBAL_ENTER_KEY, GLOBAL_ESCAPE_KEY
      // console.log('key', event.key);
      if (event.key === VALUE_ENTER && event.ctrlKey) { // ctrl + enter
        if(event.shiftKey) {// ctrl+ shift + enter : save & add
          WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.GLOBAL_ENTER_ADD_KEY, null));
        } else {
          WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.GLOBAL_ENTER_KEY, null));
        }
      } else if ( event.key.toLowerCase() === VALUE_X && event.shiftKey && event.ctrlKey) { // ctrl + shift + x => cancel
        WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.GLOBAL_BACK_KEY, null));
      } else if ( event.key.toLowerCase() === VALUE_L
                  && event.shiftKey && event.ctrlKey) { // ctrl + shift + L, pour retour de focus dans la liste
        WizEventManager.dispatchEvent(this.elementRef, new WizEvent(WIZ_EVENT_TYPE.GLOBAL_LIST_KEY, null));
      }
    }
  }

}
